import { JSX } from 'react';
import { TextField } from '@mui/material';
import { formatPhoneNumber } from 'src/utils/formatPhoneNumber';
import { formatPhoneNumber as formatPhoneStatic } from 'src/utils/InputValidationUtils';

interface Props {
  value: string;
  onChange: (v: string) => void;
}

export default function PhoneInput({ value, onChange }: Props): JSX.Element {
  return (
    <TextField
      fullWidth
      value={formatPhoneStatic((value ?? '').replace(/[^\d]/g, ''))}
      onChange={(e) => onChange(formatPhoneNumber(e.target.value, value) ?? '')}
      inputProps={{ inputMode: 'tel', 'data-testid': 'phone-input' }}
      placeholder="(555) 123-4567"
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
    />
  );
}
